import Backbone from 'backbone'
import template from './status-form.hbs'
import formHelper from 'scoreboard/components/form-helper'
import DateInput from 'scoreboard/components/date-input'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import MarkedField from 'scoreboard/components/marked-field'
import numericValidator from 'scoreboard/components/validators/numeric-validator'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import FormView from 'scoreboard/components/form-view'
import numericRangeValidatorFactory from 'scoreboard/components/validators/numeric-range-validator-factory'
import KeyCodes from 'scoreboard/components/key-codes'
import Tooltip from 'scoreboard/components/tooltip'
import scrollContainer from 'scoreboard/components/scroll-container'
import guardConstants from 'scoreboard/components/unsaved/guard-constants'
import DataType from 'scoreboard/datasets/model/data-type'
const { CURRENCY } = DataType

/**
 * This is the form on the initiatives overview which may appear in the
 * historical panel when the table view is selected.
 */
var StatusForm = Backbone.View.extend({

	// this.model is the initiative
	// this.options.status is the status shown in the form

	tagName: 'tr',

	events: {
		'click .button-primary': 'confirm',
		// forms can't be nested inside tables so we'll have to listen for
		// pressing enter on the keyboard ourselves
		'keyup': '_keyup',
		'click .button-primary.is-disabled': '_toggleValidationTooltip'
	},

	initialize: function(options) {
		this.options = options
		this.table = this.options.historicalTable

		let StatusFormView = FormView.extend({
			test: this.test.bind(this)
		})

		this.formView = new StatusFormView(this.getFormViewOptions())

		this.model.on('save:status', status => {
			this.trigger('done', status)
		})
	},

	render: function() {
		// render
		this.$el.empty().append(template())
		formHelper.writeToDom(this.options.status, this.el)

		// make sure the primary button has the correct label
		if (this.options && this.options.status && this.options.status.id) {
			this.$('.button-primary').text(i18n.get('common.save'))
		}

		// setup our fancy form controls
		this.dateInput = new DateInput({ el: this.$('.date'), required: true }).render()
		this.percentComplete = new MarkedField({
			el: this.$('.percent-complete'),
			dataType: 'percent',
			validator: [numericValidator,numericRangeValidatorFactory(0, 1, { dataType: 'percent' })],
			evaluator: numericEvaluator
		}).render()
		this.expendedToDate = new MarkedField({
			el: this.$('.expended-to-date'),
			dataType: CURRENCY,
			validator: [numericValidator, numericRangeValidatorFactory(0)],
			evaluator: numericEvaluator,
			currencyCode: this.model.get('currencyCode')
		}).render()

		this.formView.start()

		this._attachListeners()
		return this
	},

	_attachListeners() {
		scrollContainer(this.el).on('scroll', () => this._removeValidationTooltip())
		Backbone.on('navPane:expanded', () => {
			_.invoke(this.dateInput, 'removeTooltips')
			this._removeValidationTooltip()
		})
	},

	_toggleValidationTooltip: function(e) {
		if (this.validationTooltip) {
			this._removeValidationTooltip()
		} else {
			this.validationTooltip = new Tooltip({
				attachTo: this.$(e.target),
				content: i18n.get('initiatives.status.required'),
				placement: 'above',
				arrow: 'center',
				closeOnChangedFocus: false,
				closeOnAttachedToClick: false
			}).render()
		}
	},

	_removeValidationTooltip: function() {
		if (this.validationTooltip) {
			this.validationTooltip.remove()
			delete this.validationTooltip
		}
	},

	// triggers .confirm() when the enter key is pressed
	_keyup: function(e) {
		var key = e.which || e.keyCode
		if (key == KeyCodes.ENTER) {
			this.confirm(e)
		}
	},

	confirm: function(e) {
		this.formView.submit(e)
		this._removeValidationTooltip()
	},

	test: function() {
		var problem = FormView.prototype.test.apply(this, arguments)
		if (problem) {
			return problem
		}
		var status = formHelper.readFromDom(this.el)
		if (status.percentComplete == null && status.expendedToDate == null) {
			return i18n.get('initiatives.status.required')
		}
	},

	submit: function(e) {
		// if percentComplete and expendedToDate weren't specified, don't say anything
		var status = formHelper.readFromDom(this.el)
		if (status.percentComplete == null && status.expendedToDate == null) {
			this.trigger('done')
			return
		}

		status.id = this.options && this.options.status && this.options.status.id
		this.formView.dirty = false
		return this.model.saveStatus(status, this.options.treeCalculations)
	},

	getFormViewOptions: function() {
		// toggle what is shown depending on how many dirty status forms
		// there are
		const checkStatuses = (multi, single) =>
			this.table.multipleDirtyStatuses() ? multi : single

		const prompt = () => i18n.get(checkStatuses(
			'initiatives.modified.unsaved', 'common.save.prompt'))
		const save = () => i18n.get(checkStatuses(
			'initiatives.modified.backTo',
			'common.save'))
		const hideCancel = () => checkStatuses(true, null)
		const keepChangesFn = checkStatuses(guardConstants.HIDE_WARNING, null)
		return {
			el: this.el,
			toggleCancel: false,
			submit: this.submit.bind(this),
			guardOptions: {
				messages: {
					prompt,
					save
				},
				hideCancel,
				keepChangesFn
			}
		}
	},

	removeTooltips: function() {
		this.dateInput.removeTooltips()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([
			this.dateInput,
			this.percentComplete,
			this.expendedToDate,
			this.validationTooltip
		], 'remove')
	}

})

export default StatusForm

StatusForm.__filename__ = 'initiatives/overview/status-form.js'
